package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Note(
  public val id: String,
  public val parent_kind: String,
  public val parent_id: String?,
  public val title: String?,
  public val body: String,
  public val color: String?,
  public val is_pinned: Long,
  public val is_favorite: Long,
  public val tags: String?,
  public val attachments: String?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
